<template>
  <form ref="form">
    <input ref="file" type="file" accept=".pdf" :multiple="multiple" @change="onChange"/>
  </form>
</template>

<script>
import {getFileExt} from "@/lib/util";

export default {
  name: "consult-pdf-uploader",
  props: ['accept', 'multiple'],
  methods: {
    start() {
      this.$refs.file.click();
    },


    async onChange(e) {
      const domFile = e.target;
      const files = domFile.files;
      // 校验所有文件是否包含pdf以外的文件
      const isValid = Array.prototype.some.call(files, file => {
        const ext = getFileExt(file) || '';
        Log('file de ext', ext);
        return ext.toLowerCase() !== 'pdf';
      });

      if (isValid) {
        return '请上传pdf格式的文件';
      }


      this.$emit('pdfs', files);
      this.$refs.form.reset();
    }
  },
}
</script>

<style scoped lang="scss">
@import "~@/common/public.scss";

form {
  position: fixed;
  left: 100vw;
  top: 100vh;
  height: 0px;
  width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/plugins/consult/consult-pdf-uploader.vue